(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page-universe"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initUniversePagination() {
      var pages = Array.prototype.slice.call(document.querySelectorAll('[data-universe-page]'));
      var footer = document.querySelector('.footer');

      if (pages.length < 2) {
        if (footer) footer.classList.remove('footer--bordered');
        return;
      }

      var current = 0;

      var nav = document.createElement('nav');
      nav.className = 'site-pagination';
      nav.setAttribute('aria-label', 'Universe pagination');

      var label = document.createElement('span');
      label.className = 'site-pagination__item';
      label.textContent = 'Page';
      nav.appendChild(label);

      var links = pages.map(function (page, index) {
        var link = document.createElement('button');
        link.type = 'button';
        link.className = 'site-pagination__item';
        link.textContent = index + 1;
        link.addEventListener('click', function () {
          goTo(index, { scroll: true });
        });
        nav.appendChild(link);
        return link;
      });

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'site-pagination__item site-pagination__next';
      next.textContent = '>';
      next.setAttribute('aria-label', 'Next page');
      next.addEventListener('click', function () {
        if (current < pages.length - 1) goTo(current + 1, { scroll: true });
      });
      nav.appendChild(next);

      function goTo(index, options) {
        options = options || {};
        current = index;

        pages.forEach(function (page, i) {
          page.hidden = i !== current;
        });
        links.forEach(function (link, i) {
          link.classList.toggle('is-active', i === current);
        });
        next.disabled = current === pages.length - 1;

        pages[current].insertAdjacentElement('afterend', nav);

        if (options.scroll) {
          pages[current].scrollIntoView({ block: 'start' });
        }
      }

      goTo(0);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initUniversePagination);
    } else {
      initUniversePagination();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
